import { useState, useEffect } from 'react';
import { Thumbmark } from '@thumbmarkjs/thumbmarkjs';

export function useFingerprint(): string | undefined {
  const [state, setState] = useState<string | undefined>(undefined);

  useEffect(() => {
    let aborted = false;
    async function getFingerprint() {
      try {
        const tm = new Thumbmark();
        const result = await tm.get();
        if (!aborted) {
          setState(result.thumbmark);
        }
      } catch (e) {
        if (!aborted) {
          setState(undefined);
        }
      }
    }

    getFingerprint();
    return () => {
      aborted = true;
    };
  }, []);

  return state;
}
